import React from 'react';
import SafetyMRContents from '../../../component/Safety/MR/SafetyMRContents';

const MR = () => {
  return <SafetyMRContents />;
};

export default MR;
